import { Header } from './Header'
import { Message } from './Message'
import { RequestCard as Root } from './RequestCard'

export const RequestCard = {
  Root,
  Message,
  Header,
}

